export const APP_BASE = import.meta.env.VITE_BASE || '';
export const API_SERVER = import.meta.env.VITE_SERVER || '';
